import React, { Component } from 'react';

export default class SelectField extends Component {
    handleChange = (e) => {
        this.props.onChange(this.props.fieldDef.fieldId, e.target.value);
    };

    render() {
        const { fieldDef, value, hasError, errorMessage, disabled } = this.props;
        const options = fieldDef.options || [];
        const isRequired = fieldDef.validation && fieldDef.validation.required;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <select
                    className={hasError ? 'form-control select is-invalid' : 'form-control select'}
                    name={fieldDef.fieldId}
                    value={value || ''}
                    onChange={this.handleChange}
                    disabled={disabled}
                >
                    <option value="">{fieldDef.placeholder || 'Select...'}</option>
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
